import { NavLink, Outlet } from "react-router-dom";
import CompanySwitcher from "./CompanySwitcher";
import { api } from "../lib/api";

interface Props { onLogout: () => void }

const NAV = [
  { to: "/",          label: "Dashboard" },
  { to: "/clients",   label: "Clients" },
  { to: "/import",    label: "Import" },
  { to: "/templates", label: "Templates" },
  { to: "/send",      label: "Send" },
  { to: "/log",       label: "Send log" },
];

export default function Layout({ onLogout }: Props) {
  async function logout() {
    await api("/api/auth/logout", { method: "POST" });
    onLogout();
  }
  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-20 border-b border-slate-200/70 bg-white/75 backdrop-blur-md">
        <div className="mx-auto flex max-w-7xl items-center gap-5 px-6 py-3.5">
          <div className="flex items-center gap-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-md bg-gradient-to-br from-slate-800 to-slate-950 text-[11px] font-bold text-white shadow-soft">M</div>
            <div className="text-[15px] font-semibold tracking-tightish text-slate-900">
              MailBIT <span className="text-slate-400">·</span> <span className="font-normal text-slate-500">Collection</span>
            </div>
          </div>
          <div className="ml-1"><CompanySwitcher /></div>
          <nav className="ml-auto flex items-center gap-0.5 text-sm">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-1.5 font-medium transition ${
                    isActive
                      ? "bg-slate-900 text-white shadow-soft"
                      : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                  }`}
              >
                {n.label}
              </NavLink>
            ))}
            <div className="mx-2 h-5 w-px bg-slate-200" />
            <button onClick={logout} className="btn-ghost">Sign out</button>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
